import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLoadingSpinner = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	id: "loading_spinner_icon",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("style", { children: "@keyframes spin-animation{0%{transform:rotate(0deg)}to{transform:rotate(360deg)}}@keyframes spring{0%{stroke-dashoffset:.2}50%{stroke-dashoffset:.8}}" }), /* @__PURE__ */ _jsx("circle", {
		cx: 12,
		cy: 12,
		r: 10.8,
		fill: "none",
		stroke: "currentColor",
		strokeDasharray: 1,
		strokeDashoffset: .2,
		strokeLinecap: "round",
		strokeWidth: 2.4,
		pathLength: 1,
		style: {
			transformOrigin: "center center",
			animation: "spin-animation linear infinite .8s,spring cubic-bezier(.46,.03,.52,.96) infinite 2s"
		}
	})]
});
export { SvgLoadingSpinner as ReactComponent };
